import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
import { useSelector } from "react-redux";
const Holidays = (props) => {
  const { t } = useTranslation();
  const language = useSelector((state)=> state.languages?.data)

  const [attributes] = useState(() => {
    const baseAttributes = [
      {
        type: "text",
        placeholder: "title",
        name: "title",
        validation: "",
        default: "",
        label: "title",
        required: true,
        view: true,
        add: true,
        update: true,
      },
    ];

    language.length >0 && language?.map((item)=>{
      baseAttributes.push({
        type: "text",
        placeholder: item.id?.toLowerCase(),
        name: item.id?.toLowerCase(),
        validation: "",
        default: "",
        label: item.id?.toLowerCase(),
        required: false,
        view: true,
        add: true,
        update: true,
      })
    })
  
    // // If the user's role is "super", add the "en" object to the array
    // if (user.data?.user?.role === "super") {
      baseAttributes.push({
        type: "date",
        placeholder: "date",
        name: "holidayFrom",
        validation: "",
        default: "0",
        label: "holidayFrom",
        interval:1,
        required: true,
        view: true,
        add: true,
        update: true,
      });
      baseAttributes.push({
        type: "date",
        placeholder: "date",
        name: "holidayTo",
        validation: "",
        default: "0",
        label: "holidayTo",
        interval:1,
        required: true,
        view: true,
        add: true,
        update: true,
      });
    // }
  
    return baseAttributes;
  });

  //to update the page title
  useEffect(() => {
    document.title = `${t("holidays")} - PersoBase`;
  }, [t]);
  // const [actions] = useState([{ element: "button", icon: "timings", type: "subList", id: "shift-timing", itemTitle: "title", title: "timings", attributes: timingAttributes, params: { api: `timing`, itemTitle: "title", shortName: "Timing", addPrivilege: true, delPrivilege: true, updatePrivilege: true, customClass: "medium" } }]);
  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      <ListTable {...props} api={`holiday`} itemTitle={`title`} shortName={`holiday`} addPrivilege={true} delPrivilege={true} updatePrivilege={true} attributes={attributes}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Holidays);
